export const PACKAGING_TYPES = {
  BOX: 'box',
  PALLET: 'pallet',
  CONTAINER: 'container',
}

export const PACKAGING_TYPE_LABELS = {
  [PACKAGING_TYPES.BOX]: 'Box',
  [PACKAGING_TYPES.PALLET]: 'Pallet',
  [PACKAGING_TYPES.CONTAINER]: 'Container',
}

export const PACKAGING_TYPES_LIST = [
  PACKAGING_TYPES.BOX,
  PACKAGING_TYPES.PALLET,
  PACKAGING_TYPES.CONTAINER,
]

export const PACKAGING_TYPES_OPTIONS = PACKAGING_TYPES_LIST.map((type) => ({
  label: PACKAGING_TYPE_LABELS[type],
  value: type,
}))
